import(/* webpackMode: "eager" */ "/vercel/path0/apps/terminal/app/ninxl/v1/page.tsx");
